var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackLeftArm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 106,
    viewBox: "0 0 35 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4857 17.3327C34.0722 30.7695 29.1549 36.3425 29.1549 36.3425C29.1549 39.2275 25.1513 44.4284 23.84 46.8322C25.1513 51.0283 23.9493 57.1042 23.1843 59.6177L16.628 79.942C17.4147 83.8759 17.2836 88.4653 17.2836 88.4653C17.2836 88.4653 16.8465 94.3661 16.628 95.6773C16.628 100.267 15.9723 103.873 15.6445 103.545C15.3822 103.283 15.1793 96.6564 14.9889 95.6773C14.7984 94.6982 14.4706 95.026 14.3332 95.6773C14.1958 96.3286 13.6776 105.512 13.0219 105.184C12.4974 104.922 12.8846 96.6564 12.6941 95.6773C12.5037 94.6982 12.1758 95.026 12.0385 95.6773C11.9011 96.3286 10.3994 106.168 9.74375 105.512C9.21923 104.987 9.74375 98.5185 10.0716 95.3495C10.0716 94.5628 9.63452 95.0217 9.41599 95.3495C8.43253 100.267 6.4656 104.856 5.80996 104.201C5.28545 103.676 7.91409 90.7645 6.7934 92.3992C5.6727 94.0338 2.3945 96.0007 1.8761 95.3495C1.3577 94.6983 3.95229 90.8693 4.49866 89.121C5.1543 88.1375 4.82648 85.1871 6.46558 83.8758C7.77686 82.8268 9.41596 79.942 10.0716 78.6307L11.3829 59.6177C11.1207 53.848 13.022 48.2532 14.0055 46.177C12.6942 39.3583 15.7819 29.1343 17.2836 23.8851C17.2836 20.9388 17.2556 20.9456 17.2836 19.9553C17.4226 15.038 17.83 12.0836 18.5949 10.1166C21.2175 2.77347 27.9871 0.732832 31.0441 0.630404C31.5805 1.44134 33.0706 7.8207 33.4857 17.3327Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.042 46.832C17.0255 47.2691 19.4513 48.0122 21.2871 47.4877",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackLeftArm);
export default __webpack_public_path__ + "static/media/BackLeftArm.10127c0a07e3cf9d4214e671ae1bcdc5.svg";
export { ForwardRef as ReactComponent };